export * from './PromoType';
